import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect, useState } from "react";
import { useAtom } from "jotai";
import {
  emailAtom,
  emailValidAtom,
  messageForLoginModalAtom,
} from "@/store/atoms";
import { useAuth, useI18N, useVerifyEmail } from "common/hooks";
import { AuthModalScreen, useAuthModals } from "@/hooks/useAuthModals";
import Loader from "@/components/common/Loader";
import { useDarkMode } from "@/hooks/useDarkMode";
import { useCustomToast } from "@/hooks/useCustomToast";
import { Helmet } from "react-helmet-async";

export const Route = createFileRoute("/verifyuser/$code/user/$email")({
  component: VerifyUser,
});

function VerifyUser() {
  const navigate = useNavigate({ from: "/" });
  const i18n = useI18N();
  const isDark = useDarkMode();
  const { isLoading, isFetching, isLoggedIn } = useAuth();
  const isAuthLoading = isLoading || isFetching;
  const { showModal } = useAuthModals();
  const [, setEmail] = useAtom(emailAtom);
  const [, setEmailValid] = useAtom(emailValidAtom);
  const [, setMesageForLoginModal] = useAtom(messageForLoginModalAtom);
  const { code, email } = Route.useParams();
  const [verifyUserEmailInitiated, setVerifyUserEmailInitiated] =
    useState(false);

  // Decode the URL-encoded user parameter
  const decodedUserEmail = decodeURIComponent(email);

  const showToast = useCustomToast();

  const {
    verifyUserEmail,
    error,
    isLoading: isVerifyLoading,
    result,
  } = useVerifyEmail();

  useEffect(() => {
    if (isLoggedIn) {
      //redirect to home page
      navigate({ to: "/" });
    }
  }, [isLoggedIn, navigate]);

  useEffect(() => {
    if (!isVerifyLoading && error) {
      showToast(
        "You've tried to use verify too many times. Please try again in 5 minutes.",
        "error",
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [error, isDark, isVerifyLoading]);

  useEffect(() => {
    if (!isVerifyLoading && result) {
      // console.log("result", result);
      setEmail(decodedUserEmail);
      setEmailValid(true);
      // setMesageForLoginModal(i18n.get("verifyThanksMessage"));

      setMesageForLoginModal(result.message);

      showModal(AuthModalScreen.EnterEmail);

      //redirect to home page
      navigate({ to: "/" });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isVerifyLoading, result]);

  useEffect(() => {
    if (!verifyUserEmailInitiated && code && decodedUserEmail) {
      console.log(
        "calliong verifyUserEmail code && decodedUserEmail",
        code,
        decodedUserEmail,
      );

      //call method to update and verify email by sending api request at https://devbackend.sociability.app/api/v2/user/verify-user-email
      verifyUserEmail({ token: code, email: decodedUserEmail });

      setVerifyUserEmailInitiated(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [code, decodedUserEmail, verifyUserEmailInitiated]);

  return (
    <>
      <Helmet>
        <title>Verifying your email - Sociability</title>
      </Helmet>
      <div>
        <h1 className="sr-only">Verifying your email</h1>
        {isAuthLoading && <Loader />}
      </div>
    </>
  );
}
